export default {
  //* addUpdate ---------------------------------------------------------------------------------------------------------------

  async addUpdate({ rootGetters /*, commit*/ }, payload) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    // console.log(payload);
    try {
      await fetch(base_address + "/addUpdate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
        body: JSON.stringify(payload),
      }).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },
  //* addUpdate ---------------------------------------------------------------------------------------------------------------

  async setUpdateViewed({ rootGetters /*, commit*/ }, payload) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    // console.log(payload);
    try {
      await fetch(base_address + "/setUpdateViewed", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
        body: JSON.stringify(payload),
      }).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },
  //* deleteUpdate ---------------------------------------------------------------------------------------------------------------

  async deleteUpdate({ rootGetters /*, commit*/ }, payload) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    // console.log(payload);
    try {
      await fetch(base_address + "/deleteUpdate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
        body: JSON.stringify(payload),
      }).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* getUpdate ---------------------------------------------------------------------------------------------------------------

  async getUpdate({ rootGetters /*, commit*/ }) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    try {
      await fetch(base_address + "/getUpdate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* getUpdate ---------------------------------------------------------------------------------------------------------------

  async getAllOldUpdate({ rootGetters /*, commit*/ }) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    try {
      await fetch(base_address + "/getAllOldUpdate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* getUpdate ---------------------------------------------------------------------------------------------------------------

  async getUpdatableCampings({ rootGetters /*, commit*/ }) {
    var tok = "Bearer " + rootGetters["auth/getToken"];
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    try {
      await fetch(base_address + "/getUpdatableCampings", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }).then(async (response) => {
        if (response.ok) {
          exitStatus = 200;
          exitStatus = await response.json(); // means ok, all right (http protocol)
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },
};
